(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
(function (global) {
  'use strict';
  function create(options) {
    var o = options || {}, library = o.library || global.StikkmaMotifs;
    var tools = global.StikkmaMotifTools;
    if (!library || !library.loaded || !tools) throw new TypeError('Load the motif library first');
    var legacyDimensions = {heart: {w: 70, h: 54}, mountain: {w: 90, h: 54}, paw: {w: 56, h: 54}};
    function selection(config) { return tools.migrateSelection(config, library, o.legacyAliases || {}); }
    function motif(config) {
      var s = selection(config);
      if (s.legacyKind) return {id: s.motifId, label: s.motifLabel, legacyKind: s.legacyKind,
        sourceSize: legacyDimensions[s.legacyKind], selection: s};
      var m = library.get(s.motifId);
      return m ? {id: m.id, label: m.label, sourceSize: m.styles[s.motifStyle].sourceRect, selection: s} : null;
    }
    function box(value) {
      if (!value) return null;
      if (Number.isFinite(value.w)) return value;
      return {x: value.left, y: value.top, w: value.right - value.left, h: value.bottom - value.top};
    }
    return {
      applySelection: function (config, detail) {
        var s = library.selection(detail.motifId, detail.motifStyle);
        config.motifId = s.motifId; config.motifStyle = s.motifStyle; config.motif = s.motifId;
        if (detail.reason !== 'style' && detail.reason !== 'external') config.manual = false;
        return config;
      },
      normalizeSavedConfig: function (saved) {
        var result = Object.assign({}, saved), s = selection(saved);
        result.motifId = s.motifId; result.motifStyle = s.motifStyle;
        result.motif = s.legacyKind || s.motifId;
        if (Array.isArray(saved.quantities)) result.quantities = saved.quantities.slice();
        if (s.invalidOriginalId) result.invalidMotifId = s.invalidOriginalId;
        return result;
      },
      hasMotif: function (config) { return !!motif(config); },
      hasEmbroidery: function (config) {
        return !!config.personal && ((typeof config.name === 'string' && config.name.trim().length > 0) || !!motif(config));
      },
      label: function (config) { var m = motif(config); return m ? m.label : 'Ohne Motiv'; },
      prepare: function (config) {
        var m = motif(config);
        return m && !m.legacyKind ? library.prepare(m.id, m.selection.motifStyle) : Promise.resolve(null);
      },
      metrics: function (config, maxSide) {
        var m = motif(config); if (!m) return {w: 0, h: 0};
        var source = m.sourceSize;
        var side = Number.isFinite(maxSide) ? maxSide : 82;
        var factor = side / Math.max(source.w, source.h) * Math.max(0.05, (Number(config.motifSize) || 100) / 100);
        return {w: source.w * factor, h: source.h * factor};
      },
      layout: function (config, textBox, region, maxSide) {
        var m = motif(config); if (!m) return null;
        var size = this.metrics(config, maxSide);
        return tools.placeMotif({
          region: box(region || {left: 180, right: 560, top: 650, bottom: 795}),
          textBox: box(textBox), sourceSize: m.sourceSize, width: size.w, scale: 1,
          position: config.position || 'above', gap: 10,
          manual: config.manual ? {x: Number(config.motifX) || 370, y: Number(config.motifY) || 724} : null
        });
      },
      paint: function (ctx, config, layoutBox) {
        var m = motif(config);
        if (!m || !layoutBox || layoutBox.overlap || layoutBox.w <= 0 || layoutBox.h <= 0) return false;
        if (m.legacyKind) {
          if (typeof o.paintLegacy !== 'function') return false;
          o.paintLegacy(ctx, m.legacyKind, layoutBox, config);
          return true;
        }
        return !!library.draw(ctx, m.id, m.selection.motifStyle, layoutBox);
      },
      cartProperties: function (config) {
        var m = motif(config); if (!m) return {};
        var props = m.legacyKind ? {
          '_Motiv-ID': m.id, 'Motiv': m.label, 'Motivstil': 'Als Kontur',
          '_Motivbibliothek': 'legacy-v1', '_Motivquelle': m.legacyKind
        } : library.cartProperties(m.selection);
        props['_Motivgroesse-Prozent'] = String(Number(config.motifSize) || 100);
        props['_Motivposition'] = config.position || 'above';
        props['_MotivManuell'] = config.manual ? 'ja' : 'nein';
        return props;
      }
    };
  }
  global.CuscoMotifAdapter = {create: create};
})(typeof window !== 'undefined' ? window : globalThis);

})();
